import React from "react";
import HeatMap from "colbi_web_ui/lib/components/HeatMap/HeatMap";
import { mapMetadataToHeatMap } from "../../../utils/mapMetadata";

const HeatMapOrganizationProject = (props) => {
    const { value } = props || {};
    const { aggregationDataResult, organizationModules, selectedYear, yearType, appTheme } =
        value || {};

    const heatMapList = mapMetadataToHeatMap(
        aggregationDataResult,
        yearType || "fiscalyear",
        selectedYear || "N/A",
    );

    return (
        <>
            {(organizationModules || []).find((element) => element === "aggregate_org_data") && (
                <HeatMap
                    heatMapList={heatMapList}
                    fiscalYear={selectedYear}
                    type="colorHeatMap"
                    theme={appTheme || "sovos"}
                />
            )}
        </>
    );
};

export default HeatMapOrganizationProject;
